export class PaginationOptionsModel {
    public labelPrevious: string = "Previous";
    public labelNext: string = "Next";
    public labelFirst: string = "First";
    public labelLast: string = "Last";
    public labelSkip: string = "...";
    public buttonsCount: number = 10;
    public queryKey: string = "pageNumber";
}
